import {
  HTTP_GETFORECASTLIST5_FETCHING,
  HTTP_GETFORECASTLIST5_SUCCESS,
  HTTP_GETFORECASTLIST5_FAILED,
  HTTP_RESET_FORECASTLIST5,
  server,
} from "../../Constants";
import { httpClient } from "../../utils/HttpClient";

export const setStateGetForecastToFetching5 = () => ({
  type: HTTP_GETFORECASTLIST5_FETCHING,
});

export const setStateGetForecastToSuccess5 = (payload) => ({
  type: HTTP_GETFORECASTLIST5_SUCCESS,
  payload,
});

export const setStateGetForecastToFailed5 = (payload) => ({
  type: HTTP_GETFORECASTLIST5_FAILED,
});

export const clearForecast5 = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_FORECASTLIST5 });
  };
};
export const getForecast5 = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearcode,
  yearid
) => {
  return async (dispatch) => {
    dispatch(setStateGetForecastToFetching5());
    try {
      const result = await httpClient.get(
        `${server.GETFORECAST5_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearcode}/${yearid}`
      );

      dispatch(setStateGetForecastToSuccess5(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateGetForecastToFailed5());
      return Promise.reject(error.message);
    }
  };
};
